// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';

type Props = {
  singleLine: boolean,
};

export default styled<any, Theme, Props>('h2')`
  color: ${props => props.theme.carblock.title.color};
  font-size: calc(${props => props.theme.carblock.title.fontSize} * .8);
  margin: 0;
  ${({ singleLine }) => singleLine && css`
    line-height: 1;
  `}

  &:first-line {
    font-size: ${props => props.theme.carblock.title.fontSize};
  }
`;
